<template>
  <div class="inside_pages_right">
    <!-- <AuthorityManagement></AuthorityManagement> -->
    <div class="inside_pages_right_content">
      <!-- 访问权限 -->
      <div class="inside_pages_content_two">
        <div class="content_top_two">
          <el-radio-group v-model="authorityCategory" size="medium">
            <el-radio-button
              :label="value.id"
              v-for="(value, key) in $store.state.select.authorityCategory"
              :key="key"
              :value="value.id"
            >
              {{ value.nameOne }}
            </el-radio-button>
          </el-radio-group>
        </div>
        <div class="all">
          <el-button size="mini" type="success" plain @click="authorizeAll"
            >全部授权</el-button
          >
          <el-button size="mini" type="warning" plain @click="cancelAll"
            >全部取消</el-button
          >
        </div>
        <div class="access_authority_box" v-if="authorityCategory == 0">
          <el-checkbox-group v-model="selectedPcList" size="mini">
            <el-checkbox-button
              v-for="(value, index) in pcDataList"
              :label="value.id"
              :key="index"
              @change="selectOneData(value, $event)"
            >
              {{ value.authorizationName }}
            </el-checkbox-button>
          </el-checkbox-group>
        </div>

        <div class="access_authority_box" v-if="authorityCategory == 1">
          <el-checkbox-group
            fill="rgba(64,158,255,0.2)"
            text-color="#303030"
            class="checkbox_group_box"
            v-model="selectedAppList"
            size="mini"
            @change="selectDataAction"
          >
            <el-checkbox-button
              class="checkbox_button_box"
              v-for="(value, index) in appDataList"
              style="margin:3px"
              :label="value.id"
              :key="index"
              @change="selectOneData(value, $event)"
            >
              <img
                :src="value.moduleIcon"
                alt=""
                class="authority_icon"
              /><br />

              <div class="authority_name">{{ value.moduleName }}</div>
            </el-checkbox-button>
          </el-checkbox-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthorityManagement from "@/components/AuthorityManagement";
export default {
  name: "",
  components: {
    AuthorityManagement
  },
  props: {},
  data() {
    return {
      selectedPcList: [],
      selectedAppList: [],
      // 权限类别
      authorityCategory: 0,
      pcDataList: [],
      appDataList: [],
      roleInfo: JSON.parse(sessionStorage.getItem("roleInfo")) || "",
      authorizationPcList: [],
      authorizationAppList: []
    };
  },
  watch: {
    authorityCategory() {
      this.selectedPcList = [];
      this.getAuthorizationList(this.authorityCategory);
    }
  },
  computed: {},
  methods: {
    selectOneData(value, selectStatus) {
      // console.log(value)
      // console.log(selectStatus)
      if (selectStatus == false) {
        let paramData = [
          {
            roleId: this.roleInfo.roleId,
            genericId: value.id
          }
        ];
        this.delAuthorizationList(paramData);
      } else if (selectStatus == true) {
        let paramData = [
          {
            genericId: value.id,
            permissionCategory: this.authorityCategory,
            roleId: this.roleInfo.roleId
          }
        ];
        this.addAuthorizationList(paramData);
      }
    },
    selectDataAction(data) {
      var list = data;
      var listString = list.join(",");
    },

    async addAuthorizationList(paramData) {
      let res = await this.$Http.addAuthorizationList(paramData);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "添加授权成功"
        });

        this.getAuthorizationList(this.authorityCategory);
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },

    async delAuthorizationList(paramData) {
      let res = await this.$Http.delAuthorizationList(paramData);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "取消授权成功"
        });

        this.getAuthorizationList(this.authorityCategory);
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    async getPcDataList() {
      let res = await this.$Http.pcAuthorityList("");
      if (res.code == 200) {
        this.pcDataList = res.data;
        this.selectedPcList = [];
        for (var i = 0; i < this.pcDataList.length; i++) {
          for (var j = 0; j < this.authorizationPcList.length; j++) {
            if (
              this.pcDataList[i].id == this.authorizationPcList[j].genericId &&
              this.authorizationPcList[j].permissionCategory == 0
            ) {
              this.selectedPcList.push(this.pcDataList[i].id);
            }
          }
        }
        // console.log(this.selectedPcList)
        // console.log(this.pcDataList)
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },

    async getAppDataList() {
      let res = await this.$Http.appAuthorityList("");
      if (res.code == 200) {
        this.appDataList = res.data;
        this.selectedAppList = [];
        for (var i = 0; i < this.appDataList.length; i++) {
          console.log(this.authorizationAppList, "------------");
          for (var j = 0; j < this.authorizationAppList.length; j++) {
            if (
              this.appDataList[i].id ==
                this.authorizationAppList[j].genericId &&
              this.authorizationAppList[j].permissionCategory == 1
            ) {
              this.selectedAppList.push(this.appDataList[i].id);
            }
          }
        }
        // console.log(this.appDataList)
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },

    async getAuthorizationList(cates) {
      let res = await this.$Http.getAuthorizationList(
        { roleId: this.roleInfo.roleId },
        true
      );
      if (res.code == 200) {
        // console.log(11111)
        // console.log(res.data)
        // this.authorizationList = res.data;
        switch (cates) {
          case 0:
            this.authorizationPcList = [];
            res.data.forEach((element) => {
              if (element.permissionCategory == 0) {
                this.authorizationPcList.push(element);
              }
            });
            // console.log(this.authorizationPcList)
            this.getPcDataList();
            break;
          case 1:
            this.authorizationAppList = [];
            res.data.forEach((element) => {
              if (element.permissionCategory == 1) {
                this.authorizationAppList.push(element);
              }
            });
            this.getAppDataList();
            break;
        }
      } else if (res.code == 101) {
        switch (cates) {
          case 0:
            this.authorizationPcList = [];
            this.getPcDataList();
            break;
          case 1:
            this.authorizationAppList = [];
            this.getAppDataList();
            break;
        }
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },

    authorizeAll() {
      let paramData = [];
      if (this.authorityCategory == 0) {
        paramData = this.pcDataList.map((element) => {
          return {
            genericId: element.id,
            permissionCategory: this.authorityCategory,
            roleId: this.roleInfo.roleId
          };
        });
      } else {
        paramData = this.appDataList.map((element) => {
          return {
            genericId: element.id,
            permissionCategory: this.authorityCategory,
            roleId: this.roleInfo.roleId
          };
        });
      }
      this.addAuthorizationList(paramData);
    },
    cancelAll() {
      let paramData = [];
      if (this.authorityCategory == 0) {
        paramData = this.pcDataList.map((element) => {
          return {
            roleId: this.roleInfo.roleId,
            genericId: element.id
          };
        });
      } else {
        paramData = this.appDataList.map((element) => {
          return {
            roleId: this.roleInfo.roleId,
            genericId: element.id
          };
        });
      }

      this.delAuthorizationList(paramData);
    }
  },
  created() {
    this.getPcDataList();
    this.getAppDataList();
  },
  mounted() {
    if (this.roleInfo == "") {
      this.$Common.pageJump("/authority_settings", 3);
    }
    this.authorityCategory = 0;
    this.getAuthorizationList(this.authorityCategory);
  }
};
</script>
<style scoped>
@import "/css/base.css";
@import "/css/authority.css";
.all {
  margin-bottom: 10px;
}
</style>
